import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Recycle, Truck, ShoppingCart, CheckCircle2, Package, Shield } from 'lucide-react';

export const Services = () => {
  const services = [
    {
      icon: Recycle,
      title: 'Reifenentsorgung',
      description: 'Fachgerechte und umweltfreundliche Entsorgung von Altreifen gemäß kantonalen Vorschriften.',
      features: ['Kantonal bewilligt', 'Nachhaltig & umweltfreundlich', 'Alle Reifentypen']
    },
    {
      icon: ShoppingCart,
      title: 'Grosshandel Reifen',
      description: 'Umfangreiches Sortiment an Reifen für PKW, LKW, Landwirtschaft und Industrie.',
      features: ['Alle Marken', 'Kompetitive Preise', 'Grosse Auswahl']
    },
    {
      icon: Package,
      title: 'Felgen aller Art',
      description: 'Breites Angebot an Felgen verschiedener Größen und Designs für jeden Bedarf.',
      features: ['Stahl & Aluminium', 'Verschiedene Größen', 'Hochwertige Qualität']
    },
    {
      icon: Truck,
      title: 'Abholservice',
      description: 'Zuverlässiger Abhol- und Lieferservice für Ihre Reifen und Felgen.',
      features: ['Flexible Termine', 'Schnelle Lieferung', 'Regional verfügbar']
    },
    {
      icon: Shield,
      title: 'B2B-Lösungen',
      description: 'Maßgeschneiderte Lösungen für Autowerkstätten und Reifenhändler.',
      features: ['Partner-Programme', 'Mengenrabatte', 'Zuverlässiger Service']
    },
    {
      icon: CheckCircle2,
      title: 'Beratung',
      description: 'Professionelle Beratung zu allen Fragen rund um Reifen und Entsorgung.',
      features: ['Expertenwissen', 'Individuelle Lösungen', 'Kostenlose Erstberatung']
    }
  ];

  return (
    <section id="services" className="py-24 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Unsere Dienstleistungen
          </h2>
          <p className="text-lg text-muted-foreground">
            Umfassende Lösungen für Reifenentsorgung und Grosshandel – professionell, umweltfreundlich und zuverlässig
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card 
              key={index} 
              className="group hover:shadow-xl transition-all duration-300 border-border hover:border-primary/50 flex flex-col"
            >
              <CardHeader>
                <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary group-hover:scale-110 transition-all duration-300">
                  <service.icon className="w-7 h-7 text-primary group-hover:text-primary-foreground" />
                </div>
                <CardTitle className="text-xl font-semibold text-foreground" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                  {service.title}
                </CardTitle>
                <CardDescription className="text-muted-foreground">
                  {service.description}
                </CardDescription>
              </CardHeader>
              <CardContent className="mt-auto">
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-foreground">
                      <CheckCircle2 className="w-4 h-4 text-secondary mr-2 flex-shrink-0" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
